import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {

  constructor() { }

  isHideSidebar = true;
  hideSidebar() {
    this.isHideSidebar = !this.isHideSidebar;
  }
}
